import { intercomUSAppId } from "Constants";

const loadIntercom = () => {
  var w = window;
  var ic = w.Intercom;
  if (typeof ic === "function") {
    ic("reattach_activator");
    ic("update", w.intercomSettings);
  } else {
    var d = document;
    var i = function () {
      i.c(arguments);
    };
    i.q = [];
    i.c = function (args) {
      i.q.push(args);
    };
    w.Intercom = i;
    var l = function () {
      var s = d.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = "https://widget.intercom.io/widget/" + intercomUSAppId;
      var x = d.getElementsByTagName("script")[0];
      x.parentNode.insertBefore(s, x);
    };
    if (w.attachEvent) {
      w.attachEvent("onload", l);
    } else {
      w.addEventListener("load", l, false);
    }
  }
};

const hideIntercom = () => {
  if (window.Intercom) {
    window.Intercom("update", {
      hide_default_launcher: true,
    });
  }
};

const updateLatestWorkbookCreationTimestamp = timestamp => {
  if (window.Intercom) {
    window.Intercom("update", {
      latest_workbook_creation_at: timestamp,
    });
  }
};

const updateLatestWorksheetCreationTimestamp = timestamp => {
  if (window.Intercom) {
    window.Intercom("update", {
      latest_worksheet_creation_at: timestamp,
    });
  }
};

window.toddleIntercomAppId = intercomUSAppId;

function resetIntercomRuntime() {
  // Shutdown session
  if (window.Intercom) {
    window.Intercom("shutdown");
  }

  // Remove global
  delete window.Intercom;
  delete window.intercomSettings;
  delete window.toddleIntercomAppId;

  // Remove scripts
  document
    .querySelectorAll('script[src*="widget.intercom.io"]')
    .forEach(s => s.remove());
}

function configureIntercom(appConfig, settings = {}) {
  if (window.toddleIntercomAppId === appConfig.app_id) {
    window.Intercom("update", settings);
    return;
  }

  resetIntercomRuntime();

  var w = window;
  var ic = w.Intercom;
  if (typeof ic === "function") {
    ic("reattach_activator");
    ic("update", w.intercomSettings);
  } else {
    var d = document;
    var i = function () {
      i.c(arguments);
    };
    i.q = [];
    i.c = function (args) {
      i.q.push(args);
    };
    w.Intercom = i;

    var s = d.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = "https://widget.intercom.io/widget/" + appConfig.app_id;
    var x = d.getElementsByTagName("script")[0];
    x.parentNode.insertBefore(s, x);
  }
  window.toddleIntercomAppId = appConfig.app_id;

  window.Intercom("boot", {
    ...appConfig,
    ...settings,
  });
}

export {
  loadIntercom,
  hideIntercom,
  updateLatestWorkbookCreationTimestamp,
  updateLatestWorksheetCreationTimestamp,
  configureIntercom,
  resetIntercomRuntime,
};
